import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
생성/등록/추가 : create
삭제/제거 : delete
편집/수정 : update
상세페이지/보기 : read
리스트/보기 : readList
엑셀다운로드 : downloadExcel
*/
export const INQUIRY_MENU: PermissionTableRowType = {
  name: '문의',
  key: 'INQUIRY_MANAGE',
  subRows: [
    {
      name: '1:1 문의 관리',
      key: PERMISSION_SUBJECTS.ONE_ON_ONE_INQUIRY,
      permissions: [PERMISSION_ACTIONS.READLIST, PERMISSION_ACTIONS.READ, PERMISSION_ACTIONS.CREATE],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.ONE_ON_ONE_INQUIRY,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '1:1 문의 상세 조회',
          key: PERMISSION_SUBJECTS.ONE_ON_ONE_INQUIRY,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '1:1 문의 답변',
          key: PERMISSION_SUBJECTS.ONE_ON_ONE_INQUIRY,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
      ],
    },
    {
      name: '상품 문의 관리',
      key: PERMISSION_SUBJECTS.PRODUCT_INQUIRY,
      permissions: [
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.READ,
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.UPDATE,
      ],
      subRows: [
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.PRODUCT_INQUIRY,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '상품 문의 상세 조회',
          key: PERMISSION_SUBJECTS.PRODUCT_INQUIRY,
          permissions: [PERMISSION_ACTIONS.READ],
        },
        {
          name: '상품 문의 답변',
          key: PERMISSION_SUBJECTS.PRODUCT_INQUIRY,
          permissions: [PERMISSION_ACTIONS.CREATE, PERMISSION_ACTIONS.UPDATE],
        },
      ],
    },
  ],
};
